'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}



const _=require('pulsar-utils/dist-es6/_');
const BaseDirective=require('../../../../dist-es6/client/angularCommon/baseDirective');let

TreeListItemDirective=function(_BaseDirective){_inherits(TreeListItemDirective,_BaseDirective);function TreeListItemDirective(){_classCallCheck(this,TreeListItemDirective);return _possibleConstructorReturn(this,_BaseDirective.apply(this,arguments))}TreeListItemDirective.prototype.












factory=function factory($compile){
let directive=_BaseDirective.prototype.factory.call(this);
directive.transclude=!0;
directive.compile=function(tElement,tAttr,transclude){


var contents=tElement.contents().remove();
var compiledContents;
return function(scope,iElement,iAttr){

if(!compiledContents){


compiledContents=$compile(contents,transclude);
}






compiledContents(scope,function(clone,scope){


iElement.append(clone);

const itemButton=angular.element(iElement).parent().find('> .item');
scope.treeList.itemToElementMap.set(scope.rootItem,itemButton);
});
};
};

return directive;
};_createClass(TreeListItemDirective,[{key:'restrict',get:function(){return'E'}},{key:'objectBindings',get:function(){return['items','treeList','rootItem']}},{key:'templateUrl',get:function(){return'/templates/directives/treeListDirective/treeListItemTemplate'}}]);return TreeListItemDirective}(BaseDirective);


module.exports=TreeListItemDirective;
module.exports.prototype.factory.$inject=['$compile'];
//# sourceMappingURL=treeListItemDirective.js.map
